module.exports = __webpack_public_path__ + "static/media/test10_1.7be12d83.png";